import React, { useState } from "react";
import { Link } from "gatsby";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { motion } from "framer-motion";
import Image from "../Image.js";
import MainContainer from "../../styles/MainContainer.js";
import { AnimatePresence } from "framer-motion";
import {
   Nav,
   Navbar,
   NavLinks,
   NavLink,
   NavToggle,
   NavMenu
} from "./NavbarStyles.js";
import resume from "../../docs/resume.pdf";

const navMenuVariants = {
   hidden: {
      x: "-150vw",
      opacity: 0,
      transition: {
         x: {
            type: "spring",
            duration: 0.6
         },
         opacity: {
            duration: 0.6
         }
      }
   },
   visible: {
      x: "-50%",
      opacity: 1,
      transition: {
         x: {
            type: "spring",
            duration: 0.6
         },
         opacity: {
            duration: 0.6
         }
      }
   }
};

const navbarVariants = {
   hidden: {
      y: "-100%",
      opacity: 0
   },
   visible: {
      y: 0,
      opacity: 1,
      transition: {
         y: {
            type: "spring",
            stiffness: 85,
            duration: 0.4
         },
         opacity: {
            duration: 0.3
         }
      }
   }
};

const navLinkVariants = {
   hidden: {
      opacity: 0
   },
   visible: {
      opacity: 1,
      transition: {
         duration: 0.4,
         delay: 1.2
      }
   }
};

const logoVariants = {
   hidden: {
      // scale: 0.8,
      opacity: 0
   },
   visible: {
      // scale: 1,
      opacity: 1,
      transition: {
         duration: 0.6,
         delay: 0.8
      }
   }
};

function NavbarContainer() {
   const [navOpen, setNavOpen] = useState(false);

   const handleToggle = () => {
      setNavOpen(() => !navOpen);
   };

   return (
      <Navbar initial="hidden" animate="visible" variants={navbarVariants}>
         <MainContainer className="main-container">
            <Nav>
               <NavLinks>
                  <NavLink
                     initial="hidden"
                     animate="visible"
                     variants={navLinkVariants}
                  >
                     <Link activeClassName="active" to="/">
                        Home
                     </Link>
                  </NavLink>
                  <NavLink
                     initial="hidden"
                     animate="visible"
                     variants={navLinkVariants}
                  >
                     <ScrollLink offset={-40} activeClass="active" to="skills">
                        Skills
                     </ScrollLink>
                  </NavLink>
                  <NavLink
                     initial="hidden"
                     animate="visible"
                     variants={navLinkVariants}
                  >
                     <ScrollLink
                        offset={-40}
                        activeClass="active"
                        to="projects"
                     >
                        Projects
                     </ScrollLink>
                  </NavLink>
               </NavLinks>
               <Link to="/" className="nav-logo" style={{ display: "block" }}>
                  <motion.div
                     initial="hidden"
                     animate="visible"
                     variants={logoVariants}
                  >
                     <Image src="logo.svg" alt="logo" />
                  </motion.div>
               </Link>
               <NavLinks>
                  <NavLink
                     initial="hidden"
                     animate="visible"
                     variants={navLinkVariants}
                  >
                     <ScrollLink offset={-40} activeClass="active" to="about">
                        About
                     </ScrollLink>
                  </NavLink>
                  <NavLink
                     initial="hidden"
                     animate="visible"
                     variants={navLinkVariants}
                  >
                     <ScrollLink offset={-40} activeClass="active" to="contact">
                        Contact
                     </ScrollLink>
                  </NavLink>
                  <NavLink
                     initial="hidden"
                     animate="visible"
                     variants={navLinkVariants}
                  >
                     {/* <Link activeClassName="active" to="/resume">
                        Resume
                     </Link> */}
                     <a
                        href={resume}
                        target="_blank"
                        download="paras-mern-dev-resume.pdf"
                     >
                        Resume
                     </a>
                  </NavLink>
               </NavLinks>
               <NavToggle
                  onClick={handleToggle}
                  className={navOpen ? "open" : ""}
               >
                  <span className="long" />
                  <span className="short" />
               </NavToggle>

               <AnimatePresence>
                  {navOpen && (
                     <NavMenu
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        variants={navMenuVariants}
                     >
                        <Link to="/" onClick={handleToggle}>
                           Home
                        </Link>
                        <ScrollLink
                           style={{ cursor: "pointer" }}
                           onClick={handleToggle}
                           offset={-40}
                           to="skills"
                        >
                           Skills
                        </ScrollLink>
                        <ScrollLink
                           style={{ cursor: "pointer" }}
                           onClick={handleToggle}
                           offset={-40}
                           to="projects"
                        >
                           Projects
                        </ScrollLink>
                        <ScrollLink
                           style={{ cursor: "pointer" }}
                           onClick={handleToggle}
                           offset={-40}
                           to="about"
                        >
                           About
                        </ScrollLink>
                        <ScrollLink
                           style={{ cursor: "pointer" }}
                           onClick={handleToggle}
                           offset={-40}
                           to="contact"
                        >
                           Contact
                        </ScrollLink>
                        <a
                           href="../../docs/resume.pdf"
                           target="_blank"
                           download="paras-mern-dev-resume.pdf"
                        >
                           Resume
                        </a>
                     </NavMenu>
                  )}
               </AnimatePresence>
            </Nav>
         </MainContainer>
      </Navbar>
   );
}

export default NavbarContainer;
